<template>
  <a v-if="article" :href="`/contents/articles/${article.id}`">読みもの掲載</a>
</template>

<script setup lang="ts">
import { createClient } from 'microcms-js-sdk';
import { ref, onMounted } from 'vue';

interface ArticleBodyItem {
  fieldId: string;
  url?: string;
  items?: { fieldId: string; url?: string }[];
}

interface Article {
  id: string;
  body: ArticleBodyItem[];
}

const NESTED_FIELD_IDS = new Set(['ex_items', 'items']);
const DIRECT_FIELD_IDS = new Set(['ex_item', 'item', 'link_card_ex_item', 'link_card_item']);

const blockContainsUrl = (block: ArticleBodyItem, itemUrl: string): boolean => {
  if (DIRECT_FIELD_IDS.has(block.fieldId)) return block.url === itemUrl;
  if (NESTED_FIELD_IDS.has(block.fieldId)) return block.items?.some((item) => item.url === itemUrl) ?? false;
  return false;
};

const props = defineProps<{
  itemId: number;
  apiKey: string;
}>();

const article = ref<Article>();

onMounted(async () => {
  const client = createClient({
    serviceDomain: 'iichi',
    apiKey: props.apiKey,
  });
  try {
    const response = await client.getList<Article>({
      endpoint: 'articles',
      queries: {
        q: `https://www.iichi.com/listing/item/${props.itemId}`,
        fields: 'id,body',
        orders: '-pub_date',
        limit: 100,
      },
    });
    const itemUrl = `https://www.iichi.com/listing/item/${props.itemId}`;
    article.value = response.contents.find((a: Article) => a.body.some((block) => blockContainsUrl(block, itemUrl)));
  } catch {
    // 記事が見つからない場合は何も表示しない
  }
});
</script>
